module.exports = __webpack_public_path__ + "img/rate4.90b70468.png";